import "./circle.scss";

const Circle = ({ type }: { type: "red" | "green" | "blank" }) => {
  return <div className={`circle ${type}`} />;
};

export default Circle;
